"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Constants = _interopRequireWildcard(require("../constants/Constants"));

/************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2018 Adobe
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
var AppAssemblyResponseParser =
/*#__PURE__*/
function () {
  function AppAssemblyResponseParser() {
    (0, _classCallCheck2.default)(this, AppAssemblyResponseParser);
  }

  (0, _createClass2.default)(AppAssemblyResponseParser, [{
    key: "getUserEntitlementsFromAppAssemblyResponse",
    value: function getUserEntitlementsFromAppAssemblyResponse(responseJson) {
      var userEntitlements = [];
      var solutions = responseJson.solutions;

      for (var i in solutions) {
        if (solutions[i].enabled) {
          userEntitlements.push(solutions[i]);
        }
      }

      userEntitlements.push({
        longName: Constants.CROSS_CLOUD_CAPABILITIES
      });
      return userEntitlements;
    }
  }]);
  return AppAssemblyResponseParser;
}();

var _default = AppAssemblyResponseParser;
exports.default = _default;